import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

export const useFeatureFlagRetain = featureFlagsList => {
    const history = useHistory();
    const location = useLocation();
    const prevLocation = useRef(location);

    const hasFeatureFlagChanged = (featureFlag, location) => {
        const isMatchingPath = featureFlag.allowedPaths.some(path => path.test(location.pathname));

        return (
            prevLocation.current.search.includes(featureFlag.name) &&
            !location.search.includes(featureFlag.name) &&
            isMatchingPath
        );
    };

    const updateURLWithQueryParams = (queryParams, location) => {
        const queryStr = queryString.stringify(queryParams, {
            skipNull: true,
            skipEmptyString: true,
        });

        prevLocation.current = location;
        const urlWithQuery = `${location.pathname}?${queryStr}`;
        window.history.replaceState(null, '', urlWithQuery);
        window.location.reload();
    };

    useEffect(() => {
        const unlisten = history.listen(newLocation => {
            const queryParams = {};

            for (const featureFlag of featureFlagsList) {
                if (hasFeatureFlagChanged(featureFlag, newLocation)) {
                    queryParams[featureFlag.name] = null;
                }
            }

            if (Object.keys(queryParams).length > 0) {
                updateURLWithQueryParams(queryParams, newLocation);
            }
        });

        return () => unlisten(); // Cleanup listener on unmount
    }, [history, location, featureFlagsList]);
};
